import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { Trash } from 'iconsax-react';
import type { ComponentProps } from 'react';
import { DeleteConfirmDialog } from '../../delete-confirm-dialog-button';
import { TableActionIconButton } from './table-action-icon-button';

type BulkDeleteActionProps = {
  isLoading: boolean;
  onConfirm: (closeModal: () => void) => void;
  entityLabel?: string;
  buttonProps?: Partial<ComponentProps<typeof TableActionIconButton>>;
};

export function BulkDeleteAction({
  isLoading,
  onConfirm,
  entityLabel = 'items',
  buttonProps = {},
}: BulkDeleteActionProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <TableActionIconButton
          label='Delete'
          isLoading={isLoading}
          className='border-red-200'
          icon={
            <Trash
              color='#f47373'
              variant='TwoTone'
            />
          }
          {...buttonProps}
        />
      </DialogTrigger>
      <DialogContent align='center'>
        <DeleteConfirmDialog
          isLoading={isLoading}
          title={`Are you sure you want to delete ${entityLabel}?`}
          onConfirm={onConfirm}
        />
      </DialogContent>
    </Dialog>
  );
}
